/* eslint-disable react/jsx-one-expression-per-line */
import { Panel } from 'primereact/panel';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { parse } from 'query-string';

const i18nMessages = defineMessages({
  yourGpiRepresentative: {
    id: 'menu.your-gpi-representative',
    defaultMessage: 'Your GPI representative',
  },
  name: {
    id: 'attrs.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'attrs.email',
    defaultMessage: 'Email',
  },
});

const YourGpiRepresentative = ({ gpiRepresentativeData }) => {
  const { formatMessage } = useIntl();
  const location = useLocation();

  const params = parse(location.search);
  const gpiRepresentativeHighlight = params.gpiRepresentativeHighlight || false;

  const { parentAccountOwnerFullName, parentAccountOwnerEmail } = gpiRepresentativeData;

  return (
    <Panel
      header={
        <div className={gpiRepresentativeHighlight ? 'blinking-text' : ''}>
          {formatMessage(i18nMessages.yourGpiRepresentative)}
        </div>
      }
    >
      <div className="gpi-representative-data">
        <div>
          <strong>{formatMessage(i18nMessages.name)}</strong>:
        </div>
        <div>{parentAccountOwnerFullName}</div>
      </div>

      <div className="gpi-representative-data">
        <div>
          <strong>{formatMessage(i18nMessages.email)}</strong>:
        </div>
        <div>{parentAccountOwnerEmail}</div>
      </div>
    </Panel>
  );
};

YourGpiRepresentative.propTypes = {
  gpiRepresentativeData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default YourGpiRepresentative;
